import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Col, Container, FormGroup, Label, Row, Form, Spinner } from 'reactstrap'
import useGetRelativeCompData from './useGetRelativeCompData'
import { formValues } from 'redux-form'
import useUpdateRelCompAnalaysisData from './useUpdateRelCompAnalaysisData'

const RelativeCompForm = ({onClose,orderId}) => {

    // custom hook for get relative comp data
    const{isGetting, isGot, relativeCompError, relativeCompData} = useGetRelativeCompData(orderId);
    // update hook
    const{isPending, isSuccess,isError,updateRelativeAnalysis} = useUpdateRelCompAnalaysisData();

    // state to set rel comp data id
    const[id,setId] = useState(null);

    

    console.log("relativeCompData",relativeCompData)
    const{register, handleSubmit, formState:{errors},setValue,reset,watch} = useForm({
        defaultValues:{
            commentSection1:"",
            notsoldorlisted:"",
            statusOne:"",
            priceOne:"",
            dateOne:"",
            statusTwo:"",
            priceTwo:"",
            dateTwo:"",
            commentSection2:"",
            opinionMarVal:"",
            asOfDate:""
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    const testData = watch('statusOne')
    const testData2 = watch('statusTwo')
    console.log("statusOne",testData)
    console.log("statustwo",testData2)

    // setting the form values
    useEffect(()=>{
        if(relativeCompData && relativeCompData.relative_analysis){
            const relData = relativeCompData.relative_analysis;

            const formValues = {
                commentSection1:relData.comments_sec1 || '',
                notsoldorlisted:relData.subject_transferred_own || '',
                statusOne:relData.sale_type1 || '',
                priceOne:relData.sale_price1 || '',
                dateOne:relData.sale_date1 || null,
                statusTwo:relData.sale_type2 || '',
                priceTwo:relData.sale_price2 || '',
                dateTwo:relData.sale_date2 || null,
                commentSection2:relData.comments_sec2 || '',
                opinionMarVal: relData.opinion_market_val || '',
                asOfDate: relData.as_of_date || null
            }
            reset(formValues)
            
            setId(relData.id)
        }
    },[relativeCompData,reset])

    const onSubmit=(data)=>{
        console.log(JSON.stringify(data.commentSection1))
        const payload = {
            comments_sec1 : data.commentSection1,
            subject_transferred_own : data.notsoldorlisted,
            sale_type1 : data.statusOne,
            sale_price1 : data.priceOne,
            sale_date1 : data.dateOne,
            sale_type2 : data.statusTwo,
            sale_price2 : data.priceTwo,
            sale_date2 : data.dateTwo,
            comments_sec2 : data.commentSection2,
            opinion_market_val :data.opinionMarVal,
            as_of_date: data.asOfDate
        }

        console.log("on submit rel", payload, id)
        updateRelativeAnalysis({payload,id},{
            onSuccess:()=>{
                onClose();
            }
        })
        
    }

    if (isGetting) {
        return (
            <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner />
            </Container>
        );
    }

  return (
    <Container fluid>
        <Row>
            <Col>
                <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <FormGroup>
                        <Label htmlFor='commentSection' className='form-label'>Comments</Label>
                        <textarea
                            id='commentSection1'
                            name='commentSection1'
                            className='form-control border-primary-subtle'
                            rows={4}
                            placeholder='Enter Comments on Comparitive Analysis'
                            {...register("commentSection1")}
                        />
                    {errors.commentSection1 && <span className="text-danger">{errors.commentSection1.message}</span>}

                    </FormGroup>
                </Row>

                <Row>
                    <div className='mb-2 border-bottom pb-1'>
                        <h5 className='fw-bold'>The Appraiser has researched the sales and listing history of the subject property for the Past Three Years</h5>
                    </div>

                    <FormGroup>
                        <div className='d-flex align-items-center gap-2 mb-4'>
                            <input
                            type='checkbox'
                            className='form-check-input'
                            id='notsoldorlisted'
                            name='notsoldorlisted'
                            style={{ width: '20px', height: '20px'}}
                            
                            {...register("notsoldorlisted")}
                        />
                        <Label htmlFor='notsoldorlisted' className='form-label mb-0'>The subject has not transferred ownership or been listed for sale during this period.</Label>
                        </div>
                        <Label htmlFor='notsoldorlisted' className='form-label mb-1 ms-1'>This Subject was:</Label>
                    </FormGroup>
                </Row>
                
                <Row className='align-items-center'>
                    <Col md={3}>
                        <FormGroup>
                            {/* <Label className='form-label mb-0'>Status</Label> */}
                            <div className='d-flex align-items-center gap-4'>
                                <div className='d-flex align-items-center gap-2'>
                                    <input
                                        type='radio'
                                        className='form-check-input'
                                        id='statusOne'
                                        name='statusOne'
                                        style={{ width: '20px', height: '20px'}}
                                        value='sold'

                                        {...register("statusOne")}
                                    />
                                    <Label htmlFor='statusOne' className='form-label mb-0'>Sold</Label>
                                </div>
                                <div className='d-flex align-items-center gap-2'>
                                    <input
                                    type='radio'
                                    className='form-check-input'
                                    id='statusOne'
                                    name='statusOne'
                                    style={{ width: '20px', height: '20px'}}
                                    value='listed'
                                    {...register("statusOne")}
                                />
                                    <Label htmlFor='statusOne' className='form-label mb-0'>Listed</Label>
                                </div>
                            </div>
                        </FormGroup>
                    </Col>
                
                    <Col md={2}>
                        <FormGroup>
                            {/* <Label htmlFor='priceOne' className='form-label'>Price</Label> */}
                            <input
                                type='text'
                                id='priceOne'
                                name='priceOne'
                                className='form-control border-primary-subtle'
                                placeholder='Price'
                                {...register("priceOne")}
                                
                            />
                        {errors.priceOne && <span className="text-danger">{errors.priceOne.message}</span>}
                        </FormGroup>
                    </Col>

                    <Col  md={2}>
                        <FormGroup>
                            {/* <Label htmlFor='dateOne' className='form-label'>Date</Label> */}
                            <input
                                type='date'
                                id='dateOne'
                                name='dateOne'
                                className='form-control border-primary-subtle'
                                {...register("dateOne",{
                                    setValueAs:(value)=> value === "" ? null : value
                                })}
                                
                            />
                        {errors.dateOne && <span className="text-danger">{errors.dateOne.message}</span>}
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='align-items-center'>
                    <Col md={3}>
                        <FormGroup>
                            {/* <Label className='form-label mb-0'>Status</Label> */}
                            <div className='d-flex align-items-center gap-4'>
                                <div className='d-flex align-items-center gap-2'>
                                    <input
                                        type='radio'
                                        className='form-check-input'
                                        id='statusTwo'
                                        name='statusTwo'
                                        style={{ width: '20px', height: '20px'}}
                                        value='sold'

                                        {...register("statusTwo")}
                                    />
                                    <Label htmlFor='statusTwo' className='form-label mb-0'>Sold</Label>
                                </div>
                                <div className='d-flex align-items-center gap-2'>
                                    <input
                                    type='radio'
                                    className='form-check-input'
                                    id='statusTwo'
                                    name='statusTwo'
                                    style={{ width: '20px', height: '20px'}}
                                    value='listed'
                                    {...register("statusTwo")}
                                />
                                    <Label htmlFor='statusTwo' className='form-label mb-0'>Listed</Label>
                                </div>
                            </div>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            {/* <Label htmlFor='priceTwo' className='form-label'>Price</Label> */}
                            <input
                                type='text'
                                id='priceTwo'
                                name='priceTwo'
                                className='form-control border-primary-subtle'
                                placeholder='Price'
                                {...register("priceTwo")}
                                
                            />
                        {errors.priceTwo && <span className="text-danger">{errors.priceTwo.message}</span>}
                        </FormGroup>
                    </Col>

                    <Col  md={2}>
                        <FormGroup>
                            {/* <Label htmlFor='dateTwo' className='form-label'>Date</Label> */}
                            <input
                                type='date'
                                id='dateTwo'
                                name='dateTwo'
                                className='form-control border-primary-subtle'
                                {...register("dateTwo",{
                                    setValueAs:(value)=> value === "" ? null : value
                                })}
                                
                            />
                        {errors.dateTwo && <span className="text-danger">{errors.dateTwo.message}</span>}
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <FormGroup>
                        <Label htmlFor='commentSection2' className='form-label'>Additional Comments</Label>
                        <textarea
                            id='commentSection2'
                            name='commentSection2'
                            className='form-control border-primary-subtle'
                            rows={4}
                            placeholder='Enter Comments on Comparitive Analysis'
                            {...register("commentSection2")}
                        />
                    {errors.commentSection2 && <span className="text-danger">{errors.commentSection2.message}</span>}

                    </FormGroup>
                </Row>
                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Label htmlFor='opinionMarVal' className='form-label'>Opinion of Market Value</Label>
                            <input
                                type='text'
                                id='opinionMarVal'
                                name='opinionMarVal'
                                className='form-control border-primary-subtle'
                                placeholder='Opinion of Market Value'
                                {...register("opinionMarVal")}
                            />
                        {errors.opinionMarVal && <span className="text-danger">{errors.opinionMarVal.message}</span>}
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label htmlFor='asOfDate' className='form-label'>As of Date</Label>
                            <input
                                type='date'
                                id='asOfDate'
                                name='asOfDate'
                                className='form-control border-primary-subtle'
                                placeholder='Subject Value Creation Formula'
                                {...register("asOfDate",{
                                    setValueAs:(value)=> value === "" ? null : value
                                })}
                            />
                        {errors.asOfDate && <span className="text-danger">{errors.asOfDate.message}</span>}
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                        <Button type='submit' className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}>{ isPending ? <Spinner size="sm"/> : 'Save'}</Button>
                    </div>
                </Row>
                </Form>
            </Col>
        </Row>
    </Container>
  )
}

export default RelativeCompForm